import React, { FunctionComponent, useEffect, useState } from 'react';
import { fixDate, splitField, splitFieldForms } from '../../../shared/utils';
import serviceDetailBaseStyles from '../../../styles/atoms/service-detail-base.module.scss';
import { StartFinishView } from '../../start-finish-view';
import format from 'date-fns/format';
import { HOURS } from '../../../shared/constants';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

type TouristRoutePreviewProps = {
  detailData: any;
};

export const TouristRoutePreview: FunctionComponent<
  TouristRoutePreviewProps
> = ({ detailData }) => {
  const router = useRouter();
  const [locale, setLocale] = useState(router?.locale);
  const t = useTranslations('viewOffer');
  const sethours = (value) => {
    let hour = value.split(':')[0];
    if (Number(hour) <= 12)
      return value.split(':')[0] + ':' + value.split(':')[1] + ' AM';
    let filtro = [
      ...HOURS.map((value) => {
        return value.value.map((v) => {
          if (v === Number(hour)) {
            return value.value;
          }
        });
      }),
    ];
    filtro = filtro
      .map((v) => {
        return v.filter((v) => v !== undefined);
      })
      .filter((v) => v.length > 0);
    return filtro[0][0][0] + ':' + value.split(':')[1] + ' PM';
  };

  useEffect(() => {
    if(router.locale) {
      setLocale(router?.locale)
    }
  }, [router?.locale])
  return (
    <div className={serviceDetailBaseStyles.detailContainer}>
      <div className={serviceDetailBaseStyles.field}>
        <p>{t('recorrido')}</p>
        <StartFinishView points={detailData?.punto_ruta_turistica} />
      </div>

      <p>
        <strong>{t('duracion')}</strong>{' '}
        {Number(detailData?.duracion.split(':')[0]) + ' Horas '}
      </p>
      <br />
      <p>
        <strong>{t('horaInicio')}</strong> {sethours(detailData?.hora_inicio)}
      </p>
      <br />
      <p>
        <strong>{t('horafin')}</strong> {sethours(detailData?.hora_final)}
      </p>
      <p>
        <strong>Guía bilingüe (español e inglés):</strong> {detailData?.isBilingue === 1 ? 'Si': 'No'}
      </p>
      <p>
        <strong>Guía especializado:</strong> {detailData?.isEspecializado === 1 ? 'Si, ' + splitField(detailData?.descripcion_especialidad, locale) : 'No'}
      </p>

      {detailData.razones && splitField(detailData.razones, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('razonesParaIr')}</p>
          <p>{splitField(detailData.razones, locale)}</p>
        </div>
      )}

      {splitField(detailData.recomendaciones, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('recomendaciones')}</p>
          <p>{splitField(detailData.recomendaciones, locale)}</p>
        </div>
      )}

      {splitField(detailData.restriciones, locale) != '' && (
        <div className={serviceDetailBaseStyles.field}>
          <p>{t('restrincciones')}</p>
          <p>{splitField(detailData.restriciones, locale)}</p>
        </div>
      )}
    </div>
  );
};
